export default function SiteFooter() {
  return (
    <footer
      data-testid="app-footer"
      className="border-t border-slate-200 bg-white mt-16"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="text-sm text-slate-600 max-w-xl">
          Built by Mansi Bajaj — Product research background, building product.
        </p>
        <div className="flex items-center gap-3 text-xs font-mono tracking-widest uppercase text-slate-400">
          <span>v1.0</span>
          <span className="h-1 w-1 rounded-full bg-slate-300" />
          <span>Fintech · PM Tools</span>
        </div>
      </div>
    </footer>
  );
}
